import {useContext} from "react";
import "./NavSub.css";
import Button from "@material-ui/core/Button";
import {MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos} from "react-icons/md";
import {DataContext} from "../../../pages/ConfiguraHyundai";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

const NavSub = (props) => {

        const {
            step,
            setStep
        } = useContext(DataContext);

        return (
            // <nav className="header-sub">
            <Container fluid={true} className="contenedor-nav">

                <Row className="align-items-center row-nav justify-content-center">
                    {
                        props.btnLeft ?
                            <Col md={{span: 2, order: 1}} xs={{span: 6, order: 2}}>
                                <div className="d-flex justify-content-start">
                                    <Button
                                        className="btn-back"
                                        // className="btn-back d-none d-md-block"
                                        onClick={() => setStep(step - 1)}
                                    >
                                        <MdOutlineArrowBackIosNew className="left-icon"/>
                                        <span className="mt-1">REGRESAR</span>
                                    </Button>
                                </div>
                            </Col> :
                            <Col md={{span: 2, order: 1}} xs={{span: 6, order: 2}}/>
                    }

                    <Col md={{span: 8, order: 2}} xs={{span: 12, order: 1}}>
                        <div className="paso-label">
                            {props.numeroPaso &&
                            <span className="numero-paso">{props.numeroPaso}</span>
                            }
                            <span className="mt-1 text-center"> {props.subtitle} </span>
                        </div>
                    </Col>


                    {
                        props.btnRigth ?
                            <Col md={{span: 2, order: 3}} xs={{span: 6, order: 3}}>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        // className="btn-next d-none d-md-block"
                                        className="btn-next"
                                        onClick={() => setStep(step + 1)}
                                    >
                                        <span className="mt-1  ">Continuar</span>
                                        <MdOutlineArrowForwardIos className="left-icon"/>
                                    </Button>
                                </div>
                            </Col>
                            :
                            <Col md={{span: 2, order: 3}} xs={{span: 6, order: 3}}/>
                    }
                </Row>

                {/*{*/}
                {/*    props.btnLeft ?*/}
                {/*        <div>*/}
                {/*            <Button*/}
                {/*                className="btn-back d-none d-md-block"*/}
                {/*                onClick={() => setStep(step - 1)}*/}
                {/*            >*/}
                {/*                <MdOutlineArrowBackIosNew className="left-icon"/>*/}
                {/*                <span className="mt-1">REGRESAR</span>*/}
                {/*            </Button>*/}

                {/*        </div>*/}

                {/*        :*/}
                {/*        <div>*/}

                {/*        </div>*/}
                {/*}*/}

                {/*/!*<div className="paso-label">*!/*/}
                {/*/!*    *!/*/}
                {/*/!*</div>*!/*/}
                {/*<div className="paso-label">*/}
                {/*    {*/}
                {/*        props.numeroPaso ?*/}
                {/*            <Row className="centrar-global">*/}
                {/*                <Col xs={2} className="centrar-global">*/}
                {/*                    <span className="numero-paso">{props.numeroPaso}</span>*/}
                {/*                </Col>*/}
                {/*                <Col xs={10} className="centrar-global">*/}
                {/*                    <span> {props.subtitle} </span>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}

                {/*            :*/}
                {/*           <Row>*/}
                {/*               <Col xs={12}>*/}
                {/*                   <span> {props.subtitle} </span>*/}
                {/*               </Col>*/}
                {/*           </Row>*/}
                {/*    }*/}
                {/*</div>*/}

                {/*{*/}
                {/*    props.btnRigth ?*/}
                {/*        <div>*/}
                {/*            <Button*/}
                {/*                className="btn-next d-none d-md-block"*/}
                {/*                onClick={() => setStep(step + 1)}*/}
                {/*            >*/}
                {/*                <span className="mt-1  ">Continuar</span>*/}
                {/*                <MdOutlineArrowForwardIos className="left-icon"/>*/}
                {/*            </Button>*/}
                {/*        </div>*/}

                {/*        :*/}
                {/*        <div></div>*/}
                {/*}*/}
            </Container>
        );
    }
;

export default NavSub;
